import { isNullOrUndefined } from '@agilepoint/utils-common';
import * as validationRules from './rules';
import { IValidatorFunction, IValidationInstructions, IValidationErrors } from './types';

function getRule(name: string): IValidatorFunction | undefined {
    return (validationRules as any)[name];
}

/**
 * validates the given object against provided validation instructions.
 * @param {TObject} target the object containing the fields that needs to be validated
 * @param {IValidationInstructions} validationInstructions an object that contains the validation instructions for each field in given object
 */
export function validateObject<TObject extends Object>(target: TObject, validationInstructions: Partial<IValidationInstructions<TObject>>): IValidationErrors {

    if (isNullOrUndefined(target)) {
        throw new Error('target is invalid');
    }

    if (isNullOrUndefined(validationInstructions)) {
        throw new Error('validationInstructions is invalid');
    }

    const errors: IValidationErrors = {};

    for (const fieldName in validationInstructions) {
        if ((validationInstructions as any).hasOwnProperty(fieldName)) {
            const value = target[fieldName];

            const fieldValidationInstructions = (validationInstructions as any)[fieldName];

            const { rules } = fieldValidationInstructions;
            const fieldRules = Object.keys(rules)
                .map(ruleName => ({ options: rules[ruleName], validator: getRule(ruleName) }))
                .filter(v => v.options && v.validator !== undefined);

            fieldRules.some(fieldRule => {
                const error = fieldRule.validator!(value, fieldRule.options);
                if (error === undefined) {
                    return false;
                }
                errors[fieldName] = error;
                return true;
            });
        }
    }
    return errors;
}
